exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-bf21053e]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #efefef;\n}\n\n/* Mixins */\n.message-title[data-v-bf21053e] {\n  font-size: 16px;\n  color: #333;\n  font-weight: bold;\n  padding-right: 8px;\n}", ""]);

